import {pdpGraphQLQuery} from '@/scripts/util/productByHandle.gql'
import {GraphQLClient} from 'graphql-request'
import {GQL_END_POINT} from '@/scripts/configs/store'


async function getProductByHandle(handle) {
    const client = new GraphQLClient(GQL_END_POINT, {
        headers: {
            'X-Shopify-Storefront-Access-Token': window.theme.cartjs.storefrontApiToken,
        },
    })
    const namespace = window.Shopify.shop.includes(`staging-au`) ? `storefront` : `dtk`
    const {product} = await client.request(pdpGraphQLQuery, {
        handle: handle, namespace: namespace
    })

    return product
}

function findTag(tags, keyWord, trimKeyword = false) {
    const tag = tags && tags.find(tag => tag.includes(`${keyWord}`))
    if (trimKeyword) {
        return tag ? tag.replace(`${keyWord}`, ``) : null
    } else {
        return tag ? tag : null
    }
}

function findProductSku(variants) {
    return variants[0]?.sku ?? null
}

function findLineItemsTagValue(lineItems, key) {
    return lineItems.map(item => {
        findTag(item.tags, key, true)
    })
}

function findLineItemsSKU (lineItems) {
    return lineItems
        .map(lineItem => findProductSku(lineItem.variants))
        .join(`,`)
}

function findLineItemsURL (lineItems) {
    return lineItems
        .map((lineItem, index) => {
            if (!lineItem) {
                return
            }
            if (index === 0) {
                return lineItem.onlineStoreUrl ? lineItem.onlineStoreUrl : lineItem.handle
            } else {
                return lineItem.handle
            }
        })
        .join(`,`)
}

function findLineItemsProductTitle (lineItems) {
    return lineItems ? lineItems
        .map(lineItem => lineItem && lineItem.title)
        .join(`,`)
        .slice(0, 255) : ``
}
export {getProductByHandle, findTag, findProductSku, findLineItemsTagValue, findLineItemsSKU, findLineItemsURL,  findLineItemsProductTitle}
